export default __webpack_public_path__ + "static/media/uniswap.2cf2e528.svg";